import * as _types2 from "@near-js/types";
var _types = _types2;
try {
  if ("default" in _types2) _types = _types2.default;
} catch (e) {}
import * as _utils2 from "@near-js/utils";
var _utils = _utils2;
try {
  if ("default" in _utils2) _utils = _utils2.default;
} catch (e) {}
import * as _httpErrors2 from "http-errors";
var _httpErrors = _httpErrors2;
try {
  if ("default" in _httpErrors2) _httpErrors = _httpErrors2.default;
} catch (e) {}
import _exponentialBackoff from "./exponential-backoff";
import _fetch from "./fetch";
var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = exports && exports.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = exports && exports.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = exports && exports.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchJson = void 0;
const types_1 = _types;
const utils_1 = _utils;
const http_errors_1 = __importDefault(_httpErrors);
const exponential_backoff_1 = _exponentialBackoff;
const START_WAIT_TIME_MS = 1000;
const BACKOFF_MULTIPLIER = 1.5;
const RETRY_NUMBER = 10;
/**
 * Performs an HTTP request to a specified URL or connection and returns the parsed JSON response.
 * @param connectionInfoOrUrl The connection information or URL for the HTTP request.
 * @param json The JSON payload to be included in the request body for POST requests.
 * @returns A Promise that resolves to the parsed JSON response from the HTTP request.
 */
function fetchJson(connectionInfoOrUrl, json) {
  return __awaiter(this, void 0, void 0, function* () {
    let connectionInfo = {
      url: null
    };
    if (typeof connectionInfoOrUrl === "string") {
      connectionInfo.url = connectionInfoOrUrl;
    } else {
      connectionInfo = connectionInfoOrUrl;
    }
    const response = yield (0, exponential_backoff_1.exponentialBackoff)(START_WAIT_TIME_MS, RETRY_NUMBER, BACKOFF_MULTIPLIER, () => __awaiter(this, void 0, void 0, function* () {
      var _a;
      try {
        const response = yield ((_a = _global.fetch) !== null && _a !== void 0 ? _a : (yield Promise.resolve().then(() => __importStar(_fetch))).default)(connectionInfo.url, {
          method: json ? "POST" : "GET",
          body: json ? json : undefined,
          headers: Object.assign(Object.assign({}, connectionInfo.headers), {
            "Content-Type": "application/json"
          })
        });
        if (!response.ok) {
          if (response.status === 503) {
            utils_1.Logger.warn(`Retrying HTTP request for ${connectionInfo.url} as it's not available now`);
            return null;
          } else if (response.status === 408) {
            utils_1.Logger.warn(`Retrying HTTP request for ${connectionInfo.url} as the previous connection was unused for some time`);
            return null;
          }
          throw (0, http_errors_1.default)(response.status, yield response.text());
        }
        return response;
      } catch (error) {
        if (error.toString().includes("FetchError") || error.toString().includes("Failed to fetch")) {
          utils_1.Logger.warn(`Retrying HTTP request for ${connectionInfo.url} because of error: ${error}`);
          return null;
        }
        throw error;
      }
    }));
    if (!response) {
      throw new types_1.TypedError(`Exceeded ${RETRY_NUMBER} attempts for ${connectionInfo.url}.`, "RetriesExceeded");
    }
    return yield response.json();
  });
}
exports.fetchJson = fetchJson;
export default exports;